import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../helpers/language';
import parse from 'html-react-parser';

const AboutPageSections = () => {
  const { language } = useLanguage();
  const t = translations[language].aboutPage;

  return (
    <>
      <section className="section-image" id='about' data-aos="fade-up">
        <div className="content-image-about">
          <h1 className="content-about-title">
            {t.title_part1}
            <span className="text-span-10">{t.title_highlight}</span>
          </h1>
        </div>
      </section>

      <section className="section-about-castle" data-aos="fade-up">
        <div className="about-cotent-left">
          <div className="content-tile-icon">
            <img src="/images/cloud-blue.svg" alt="" className="image" />
            <h1 className="heading">{t.heading}</h1>
          </div>
          <p className="paragraph">{parse(t.description)}</p>
        </div>
        <div className="about-content-rigth"></div>
      </section>

      <section className="section-mission-vision" data-aos="fade-up">
        <div className="mission-vision-content">
          <div className="w-layout-grid mission-vision-grid">
            <div className="mission-vision-left">
              <img src="/images/bar-graph-blue.svg" alt="" className="image-mision-vision" />
              <h1 className="mission-vission-title">{t.mission_title}</h1>
              <img src="/images/line-blue.svg" alt="" className="image-mision-vision" />
              <p className="mission-vission-descripction">{t.mission_text}</p>
            </div>
            <div className="mission-vision-left">
              <img src="/images/eye-blue.svg" alt="" className="image-mision-vision" />
              <h1 className="mission-vission-title">{t.vision_title}</h1>
              <img src="/images/line-blue.svg" alt="" className="image-mision-vision" />
              <p className="mission-vission-descripction">{t.vision_text}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="secction-image">
        <h1 className="title-img">{t.closing_phrase}</h1>
      </section>
    </>
  );
};

export default AboutPageSections;
